ko.components.register('feedback-widget', {
	viewModel: function(params) {
		var self = this;

		self.label = ko.observable(params && params.label || 'Feedback');
		self.submitLabel = ko.observable(params && params.submitLabel || 'Submit');
		self.placeholder = ko.observable(params && params.placeholder || 'Your feedback text here...');
		self.removeConfirm = ko.observable(params && params.removeConfirm || 'Are you sure?');

		self.isOpen = ko.observable(params && params.isOpen || false);
		self.items = ko.observableArray(params && params.items || []);
		self.content = ko.observable();
		self.loading = ko.observable(false);

		self.toggle = function() {
        	self.isOpen(!self.isOpen());
		}.bind(self);

		self.ajaxRequest = function(params, callback){
			if(self.loading())
				return;
			self.loading(true);
			return App.ajaxRequest('', params, callback).always(function(){
				self.loading(false);
			});
		};

		self.loadItems = function() {
			if(!self.loading())
				self.items.removeAll();
			self.ajaxRequest({ 'action': 'list-feedbacks', url: window.location.href }, function(r){
				if(r) {
					if(r.ok) {
						if(r.items)
							for(var k in r.items)
								self.items.push(r.items[k]);
					} else if(r.error) alert(r.error);
				}
			});
        };

		self.remove = function(item) {
    		if(self.loading() || !confirm(self.removeConfirm()))
    			return;
			self.ajaxRequest({ 'action': 'remove-feedback', id: item.id }, function(r){
				if(r) {
					if(r.ok) {
						self.items.remove(item);
					} else if(r.error) alert(r.error);
				}
			});
		};
        self.add = function() {
        	if(self.content() && self.content().length > 0)
        	{
	        	if(self.loading())
	        		return;
        		var item = {
      				user: {id: window.user && window.user.id || 0, nickname: window.user && window.user.nickname || 'Me'},
        			content: self.content()
        		};
				self.ajaxRequest({ 'action': 'add-feedback', url: window.location.href, content: self.content() }, function(r){
					if(r) {
						if(r.ok) {
							if(r.item)
								self.items.unshift(r.item);
							else
								self.items.unshift(item);
							self.content('');
						} else if(r.error) alert(r.error);
					}
				});
        	}
        };

        self.loadItems();
    },
    template: "<div class=\"user-feedback-toggle\">\n\t<button class=\"btn\" data-bind=\"click: toggle, css: {'btn-light': isOpen(), 'btn-secondary': !isOpen()}\">\n\t\t<span data-bind=\"visible: !isOpen()\" class=\"ic ic-pencil\"></span>\n\t\t<span data-bind=\"visible: isOpen()\" class=\"ic ic-remove\"></span>\n\t\t<span data-bind=\"text: label\"></span>\n\t\t<span class=\"badge badge-warning\" data-bind=\"visible: !isOpen() && items().length, text: items().length\"></span>\n\t</button>\n</div>\n<div data-bind=\"visible: isOpen(), css: {'loading': loading()}\" class=\"user-feedback\">\n\t<div data-bind=\"foreach: items\" class=\"user-feedback-items\">\n\t\t<small><span class=\"text-muted mr-2\" data-bind=\"text: created\"></span>\n\t\t<strong data-bind=\"text: user.nickname\"></strong>\n\t\t<a href=\"#remove\" class=\"close\" data-bind=\"visible: editable, click: $component.remove\">&times;</a><br />\n\t\t<em data-bind=\"html: content\"></em></small><br />\n\t\t</small><br />\n\t</div>\n\t<form class=\"form\" data-bind=\"submit: add\">\n\t\t<textarea class=\"border border-gray w-100 p-2 mt-1\" data-bind=\"value: content, attr: {placeholder: placeholder}\"></textarea>\n\t\t<button class=\"btn btn-primary btn-sm w-50\" data-bind=\"text: submitLabel, disabled: loading()\"></button>\n\t</form>\n</div>"
});